import { render, staticRenderFns } from "./QcxjSettingIndex.vue?vue&type=template&id=ae1bff0c&scoped=true&"
import script from "./QcxjSettingIndex.vue?vue&type=script&lang=js&"
export * from "./QcxjSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./QcxjSettingIndex.vue?vue&type=style&index=0&id=ae1bff0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1bff0c",
  null
  
)

export default component.exports